var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Croatia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M24,4C15.421,4,8.125,9.412,5.284,17h37.431C39.875,9.412,32.579,4,24,4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M44,24c0-2.467-0.468-4.818-1.284-7H5.284C4.468,19.182,4,21.533,4,24s0.468,4.818,1.284,7h37.431 C43.532,28.818,44,26.467,44,24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d47a1",
    d: "M42.716,31H5.284C8.125,38.588,15.421,44,24,44S39.875,38.588,42.716,31z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24,32.848c-3.121,0-5.66-2.539-5.66-5.66v-6.84h11.32v6.84C29.66,30.309,27.121,32.848,24,32.848z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M29.41,20.598v6.59c0,2.984-2.426,5.41-5.41,5.41s-5.41-2.426-5.41-5.41v-6.59H29.41 M29.91,20.098 H18.09v7.09c0,3.266,2.645,5.91,5.91,5.91s5.91-2.645,5.91-5.91V20.098z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M27.371,20.434h2.238v2.453h-2.238V20.434z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M22.891,20.434h2.234v2.453h-2.234V20.434z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M18.406,20.434h2.238v2.453h-2.238V20.434z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M27.371,25.359h2.238v2.457h-2.238V25.359z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M22.891,25.359h2.234v2.457h-2.234V25.359z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M18.406,25.359h2.238v2.457h-2.238V25.359z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M27.371,31.625c0.734-0.555,1.121-1.125,1.27-1.34h-1.27V31.625z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M20.641,31.625c-0.734-0.555-1.117-1.125-1.266-1.34h1.266V31.625z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M22.891,32.645c0,0,0.398,0.109,1.121,0.109s1.113,0,1.113,0v-2.469h-2.234V32.645z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M25.129,27.816h2.238v2.457h-2.238V27.816z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M20.645,27.816h2.238v2.457h-2.238V27.816z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M25.129,22.887h2.238v2.457h-2.238V22.887z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M20.645,22.887h2.238v2.457h-2.238V22.887z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#4fc3f7",
    d: "M18.727,20.086L17.5,17.313l0.906-1.48l1.625,0.605l0.746,2.934 C20.777,19.371,19.621,19.672,18.727,20.086z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M22.91,19.023L22.668,16l-1.504-0.867l-1.137,1.305l0.75,2.93 C20.781,19.367,21.965,19.078,22.91,19.023z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M25.094,19.023L25.336,16l1.504-0.867l1.133,1.305l-0.75,2.93 C27.223,19.367,26.039,19.078,25.094,19.023z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#4fc3f7",
    d: "M25.094,19.023L25.336,16l-1.332-1.098L22.668,16l0.242,3.023 C22.91,19.023,24.242,18.918,25.094,19.023z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#4fc3f7",
    d: "M29.273,20.086l1.227-2.773l-0.906-1.48l-1.625,0.605l-0.746,2.934 C27.223,19.371,28.379,19.672,29.273,20.086z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#4fc3f7",
    d: "M29.273,20.086l1.227-2.773l-0.906-1.48l-1.625,0.605l-0.746,2.934 C27.223,19.371,28.379,19.672,29.273,20.086z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M20.219,17.176c1.578-0.352,2.07-0.398,2.508-0.43L22.668,16l-0.004-0.004 c-0.285,0.016-1.262,0.094-2.633,0.441L20.219,17.176z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M22.852,18.27l-0.063-0.762c-0.914,0.047-2.105,0.324-2.383,0.395l0.191,0.754 C21.543,18.383,22.461,18.297,22.852,18.27z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.41,18.645c1,0.258,1.785,0.582,2.168,0.754l0.473-1.066c-1.086-0.508-2.121-0.773-2.352-0.828 L27.41,18.645z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M27.461,18.438c0.297,0.066,1.105,0.277,2.199,0.773l0.313-0.703 c-0.266-0.117-1.383-0.59-2.324-0.809L27.461,18.438z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Croatia);
export default __webpack_public_path__ + "static/media/icons8-croatia.2607a688997b51dc735f5e3503ea89c1.svg";
export { ForwardRef as ReactComponent };